import { markInputRule } from 'tiptap-commands'
import CustomLink from './customlink.js'

/**
 * Plugin for the tiptap editor that sets link targets as blank and allows
 * to manually enter URLs as text.
 *
 * @see https://github.com/heyscrumpy/tiptap/blob/master/packages/tiptap-extensions/src/marks/Link.js
 */
export default class BlankAutoLink extends CustomLink {
  get schema () {
    return {
      ...super.schema,
      toDOM: node => ['a', {
        ...node.attrs,
        rel: 'noopener noreferrer nofollow',
        target: '_blank',
      }, 0],
    }
  }

  inputRules ({ type }) {
    return [
      markInputRule(
        /(https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\\+.~#?&//=]*))\s$/g,
        type,
        matches => {
          return { href: matches[1], target: '_blank' }
        }
      ),
    ]
  }
}